import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { CreateGoalInput, GoalListQuery, UpdateGoalInput } from '@teentack/shared';
import { createGoal, deleteGoal, fetchGoals, updateGoal } from './goals.api';

export const goalKeys = {
  all: ['goals'] as const,
  list: (query: Partial<GoalListQuery>) => ['goals', 'list', query] as const,
};

export function useGoals(query: Partial<GoalListQuery> = {}, enabled = true) {
  return useQuery({
    queryKey: goalKeys.list(query),
    queryFn: () => fetchGoals(query),
    enabled,
  });
}

export function useCreateGoal() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateGoalInput) => createGoal(input),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: goalKeys.all });
    },
  });
}

export function useUpdateGoal() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ goalId, ...input }: UpdateGoalInput & { goalId: string }) =>
      updateGoal(goalId, input),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: goalKeys.all });
    },
  });
}

export function useDeleteGoal() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (goalId: string) => deleteGoal(goalId),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: goalKeys.all });
    },
  });
}
